import {useTheme, Text, Stack, Callout, DefaultButton} from '@fluentui/react';
import {useUserContext} from 'authentication/UserContext';
import {useTranslation} from 'react-i18next';
import {
	getDashboardClassNames,
	MyRecentActivity,
} from './components/Common/BaseWorkBenchComponent';
import React, {useState} from 'react';
import VkoWorkbenchComponent from './components/VkoWorkbench/VkoWorkbenchComponent';
import {WorkbenchBaselineList} from './components/BedarfsWorkbench/WorkbenchBaselineList';
import {BedarfsWorkbenchSection} from './components/BedarfsWorkbench/BedarfsWorkbenchSection';
import {useStore} from 'react-context-hook';
import VkoApproverWorkbenchComponent from './components/VkoApproverWorkbench/VkoApproverWorkbenchComponent';
import {MyReviewItems} from './components/ApproverWorkbench/MyReviewItems';
import {DashboardPageVexPart} from './DashboardPageVexPart';

/* This is temporary dashboard. To be replaced with DashboardPage after being approved.
		This can be modified freely, just care to not impact original Dashboard.
		You can copy subcomponents or style classes if needed. */
const TestDashboardPage = () => {
	const {t} = useTranslation('features/dashboard', {
		keyPrefix: 'DashboardPage',
	});
	const theme = useTheme();
	const classNames = getDashboardClassNames(theme);
	const {isVex, isVko, isApprover, isBedarfskoordinator} = useUserContext();

	const [approverReviewCount, setApproverReviewCount] = useState<
		number | undefined
	>(undefined);
	const [activityItemCount, setActivityItemCount] = useState<
		number | undefined
	>(undefined);
	const renderBedarfsWorkbenchLists = () => (
		<WorkbenchBaselineList halfHeight />
	);

	const [dashboardState, setDashboardState] = useStore('dashboardState', {
		showTestCallout: isVko && isApprover,
	});

	return (
		<div style={{background: theme.palette.neutralLight}}>
			{dashboardState.showTestCallout === true && (
				<Callout
					style={{
						background: theme.palette.greenLight,
						color: theme.palette.neutralDark,
						fontWeight: 'bold',
					}}
					target={{left: window.innerWidth - 20, top: window.innerHeight / 4}}
				>
					<div style={{padding: 20}}>
						<div>{`This is test dashboard`}</div>
						<div>{`(to be approved)`}</div>
						<div style={{textAlign: 'center', paddingTop: 10}}>
							<DefaultButton
								onClick={() =>
									setDashboardState({...dashboardState, showTestCallout: false})
								}
							>
								Close
							</DefaultButton>
						</div>
					</div>
				</Callout>
			)}
			{isVko &&
				(isApprover ? (
					<VkoApproverWorkbenchComponent />
				) : (
					<VkoWorkbenchComponent />
				))}
			<DashboardPageVexPart />
			{isApprover && !isVko && (approverReviewCount || 0) > 0 && (
				<Stack horizontalAlign='start' className={classNames.WorkbenchHeader}>
					<Text className={classNames.WorkbenchHeaderText}>
						{t('ApproverOveriewHeader')}
					</Text>
				</Stack>
			)}
			{isApprover && !isVko && (
				<Stack
					horizontal
					horizontalAlign='start'
					styles={{root: {width: '100%'}}}
					grow={1}
				>
					<MyReviewItems
						halfHeight
						itemCountLoaded={(count: number) => setApproverReviewCount(count)}
					/>
				</Stack>
			)}
			{isBedarfskoordinator && (
				<BedarfsWorkbenchSection
					renderBedarfsWorkbenchLists={renderBedarfsWorkbenchLists}
					t={t}
				/>
			)}
			{isVex && activityItemCount !== 0 && (
				<MyRecentActivity
					itemCountLoaded={(count: number) => setActivityItemCount(count)}
				/>
			)}
		</div>
	);
};

export default TestDashboardPage;
